export const usageConstants = {
  USAGE_METER_DETAIL: "USAGE_METER_DETAIL",
  USAGE_USER_DATA: "USAGE_USER_DATA",
  BILL_PAY_HISTORY_API_BILL_LABEL: "Bill",
  BILL_PAY_HISTORY_API_UNPAID_VALUE: "UNPAID"
};
